import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import styled, { css } from 'styled-components';
import { space, typography } from 'styled-system';
import { color, getTextColor, themeGet, getPaletteColor } from '@magalu/stereo-ui-styles';
import { MINIATURE, LIST } from '../../constants';
import Text from '../../atoms/Text';
import Box from '../../atoms/Box';
export const Unavailable = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;
const unavailableLabelPadding = {
  [MINIATURE]: css`
    padding: 4px 4px;
  `,
  [LIST]: css`
    padding: 12px 35px;
  `,
  DEFAULT: css`
    padding: 12px 12px;
  `
};
export const UnavailableLabel = styled.span`
  font-size: ${props => themeGet('fontSizes.1')(props)}px;
  border-radius: 4px;
  color: ${props => getTextColor('light')(props)};
  display: inline-block;
  background-color: ${props => getPaletteColor('background.secondary')(props)};
  ${props => unavailableLabelPadding[props.display] || unavailableLabelPadding.DEFAULT}
`;

const resolvePriceFontSize = isList => isList ? 3 : 5;

export const PriceDefault = styled(Box).attrs(props => ({
  fontSize: [resolvePriceFontSize(props.isList), 5],
  lineHeight: 'fontSize'
}))`
  color: ${props => getTextColor('base')(props)};
  font-weight: ${props => themeGet('fontWeights.medium')(props)};
  align-self: end;
  position: relative;
  span {
    font-size: ${_ref => {
  let {
    isList
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["isList"]);

  return isList ? themeGet('fontSizes.0')(props) : themeGet('fontSizes.1')(props);
}}px;
    font-weight: ${props => themeGet('fontWeights.regular')(props)};
    line-height: ${props => themeGet('lineHeights.thin')(props)}px;
  }
  ${space}
  ${typography}
`;
export const PriceContent = styled(Box).attrs(_ref2 => {
  let style = Object.assign({}, _ref2);
  return Object.assign({
    mt: '8px'
  }, style);
})`
  line-height: ${props => themeGet('lineHeights.big')(props)};
  ${typography}
`;
export const Discount = styled(Text)`
  color: ${props => getPaletteColor('secondary.base')(props)};
  font-size: ${props => themeGet('fontSizes.0')(props)}px;
`;
export const OriginalPrice = styled(Text).attrs(({
  isList
}) => ({
  fontSize: [isList ? 0 : 1, 1],
  lineHeight: 'fontSize',
  fontWeight: !isList ? 'regular' : null,
  color: isList ? 'text.scratched' : 'text.light'
}))`
  margin: 0;
  text-align: left;
  text-decoration: line-through;
  ${typography}
  ${color}
`;
export const MethodDescription = styled.span`
  margin-left: 0.3rem;
`;
export const PriceValue = styled(Text)``;